import type StatusObject from '@/classes/SubmissionStatuses/StatusObject'
import { StatusThemeVariant } from '@/classes/SubmissionStatuses/StatusThemeVariantEnum'
import {
	type SubmissionAction,
	type SubmissionStatus,
} from '@/classes/SubmissionStatuses/types'

export class UnknownError implements StatusObject {
	submissionStatus: SubmissionStatus
	vendorName: string

	constructor(submissionStatus: SubmissionStatus, vendorName: string) {
		this.submissionStatus = submissionStatus
		this.vendorName = vendorName
	}

	getVendorName(): string {
		return this.vendorName
	}

	getUpdatedAt() {
		return this.submissionStatus.updatedAt
	}

	getActions(): Array<SubmissionAction> {
		return []
	}

	getStatusText() {
		return 'Unknown Error'
	}

	getToolTipText() {
		return {
			title: 'Unknown Error',
			body: 'Error can’t be determined at this time. Please contact salesstudio@precoa.com for assistance.',
		}
	}

	getThemeVariant() {
		return StatusThemeVariant.ERROR
	}
}
